"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {
  ApiError: true,
  ApiResponse: true
};
exports.ApiResponse = exports.ApiError = void 0;

var _flowRuntime = _interopRequireDefault(require("flow-runtime"));

var _base = require("./base");

Object.keys(_base).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _base[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _base[key];
    }
  });
});

var _validation = require("./validation");

Object.keys(_validation).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _validation[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _validation[key];
    }
  });
});

var _field = require("./field");

Object.keys(_field).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _field[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _field[key];
    }
  });
});

var _component = require("./component");

Object.keys(_component).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _component[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _component[key];
    }
  });
});

var _page = require("./page");

Object.keys(_page).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _page[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _page[key];
    }
  });
});

var _form = require("./form");

Object.keys(_form).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _form[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _form[key];
    }
  });
});

// TODO: Proper ApiError type in nova-frontend-rest-client
var ApiError = _flowRuntime["default"].type("ApiError", _flowRuntime["default"].exactObject(_flowRuntime["default"].property("code", _flowRuntime["default"].number()), _flowRuntime["default"].property("message", _flowRuntime["default"].string())));

exports.ApiError = ApiError;

var ApiResponse = _flowRuntime["default"].type("ApiResponse", _flowRuntime["default"].exactObject(_flowRuntime["default"].property("payload", _flowRuntime["default"].object()), _flowRuntime["default"].property("response", _flowRuntime["default"].ref("Response")))); // TODO: These should be export type * but that isn't support by the ES6 language


exports.ApiResponse = ApiResponse;